import { gsap } from 'gsap';
import * as Tone from "tone";
import { AppEvent } from "@/constants";
import { AudioTrack } from "@audio/index";
import { BasePlayer } from "./BasePlayer";
import { createSampleMapFromUrls } from "@/functions";
export class LoopPlayer extends BasePlayer {
    constructor({ path, name, input, config }) {
        super({ path, name, input, config });
        this._tracks = [];
        const { tracks, volume } = this.config;
        // Create track objects that play notes in the sampler
        this._tracks = tracks.map((config, id) => new AudioTrack({ id, config }));
        // Gather all options from all tracks into one sample map
        const allSrcUrls = this._tracks.map(track => track.srcPool).flat();
        const urls = createSampleMapFromUrls(allSrcUrls);
        // Create the actual sampler object
        this.sampler = new Tone.Sampler({
            urls,
            attack: 0,
            release: 2,
            curve: "linear",
            baseUrl: `./audio/${this.path}/`,
            volume: !isNaN(volume) ? volume : -9,
            onload: () => this.emit(AppEvent.LOAD_COMPLETE, this),
        });
        // Create the loops for whatever length they are per track
        this._tracks.forEach(track => track.createLoop(this.sampler));
    }
    /**
     * Handle the operations when entering a scene
     * Start all the loops that have a loop object
     */
    enterScene(scene) {
        this._tracks.filter(t => t.loop).forEach(track => track.startLoop());
        if (scene.loopsVolume !== undefined) {
            const newVolume = scene.loopsVolume;
            if (newVolume !== this.sampler.volume.value) {
                this.fadeVolumeTo({ volume: newVolume, duration: scene.fadeInDuration || 2 });
            }
        }
    }
    /**
     * Stop all audio
     */
    stopAll() {
        this._tracks.forEach(track => track.stopLoop());
    }
    /**
     * Fade the volume to a given value over a given duration
     * @param param0
     *      volume - the volume to fade to
     *      duration - the duration of the fade
     */
    fadeVolumeTo({ volume, duration }) {
        gsap.to(this.sampler.volume, { value: volume, duration: duration || 2, ease: "none" });
    }
    /**
     * Connect the sampler to the given node
     * @param node
     * @returns LoopPlayer
     */
    connect(node) {
        this.sampler.connect(node);
        this.isConnected = true;
        return this;
    }
    /**
     * Disconnect the sampler from the audio graph
     */
    disconnect() {
        this.sampler.disconnect();
        this.sampler.dispose();
        this.isConnected = false;
    }
    get tracks() {
        return this._tracks;
    }
}
